export default "__VITE_ASSET__bfc1074d__"